import router from '../router';
import Vue from '../vue';
import store from '../store';

const getMatomo = () => Vue.prototype.$matomo;
const getResolvedHref = (router, path) => router.resolve(path).href;
export const trackMatomoPageView = (to, from) => {
  const Matomo = getMatomo()

  let url = getResolvedHref(router, to.fullPath)
  let referrerUrl = from && from.fullPath ? getResolvedHref(router, from.fullPath) : undefined;

  let componentTitle = to.matched[0]?.components.default.title;
  let title = (componentTitle && `${componentTitle} - ClientAnalytics`) || document.title || url;

  if (window['matomoFunction']) {
    window['matomoFunction']();
  }

  Matomo.setUserId(store.state.user?.user?.email);
  Matomo.setCustomDimension(1, store.state.user?.client?.name);

  if (referrerUrl) {
    Matomo.setReferrerUrl(window.location.origin + referrerUrl);
  }
  if (url) {
    Matomo.setCustomUrl(window.location.origin + url);
  }

  Matomo.trackPageView(title);
  Matomo.enableLinkTracking();
}
